import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { T } from 'shared/helper/translate';
import RubriqAbstractStatus from './RubriqAbstractStatus';
var RubriqAbstractsHeader = function RubriqAbstractsHeader(_ref) {
  var creatingAbstract = _ref.creatingAbstract,
    onCreateAbstract = _ref.onCreateAbstract;
  return /*#__PURE__*/React.createElement("div", {
    className: "border-bottom d-flex justify-content-between align-items-center justify-content-md-end gap-md-4 py-2"
  }, /*#__PURE__*/React.createElement(RubriqAbstractStatus, null), /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: "btn btn-primary",
    onClick: function onClick() {
      return onCreateAbstract();
    },
    disabled: creatingAbstract
  }, /*#__PURE__*/React.createElement(T, {
    source: "New Abstract"
  }), creatingAbstract && /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    className: "ms-1",
    icon: "fa-solid fa-spinner-scale",
    spin: true
  })));
};
export default RubriqAbstractsHeader;